<template>
  <bottom-sheet
    :visible="visible"
    :close-icon-right-align="true"
    min-height="min-h-[200px]"
    @close="$emit('close')"
  >
    <div class="relative -mt-4 rounded bg-white px-2 md:mt-0">
      <h3 class="text-left text-xl text-dark-gray">Remove Capacity</h3>

      <div class="my-4 text-left">
        <p class="text-base text-steel-800">
          Are you sure you want to remove truck:
          <span class="font-semibold">
            {{
              capacity?.carrier_vehicle?.truck_number ||
              capacity.carrier_vehicle_id
            }}
          </span>
          ?
        </p>
      </div>

      <section class="mt-12 flex justify-end gap-3 md:mt-8">
        <ButtonComponent
          class="flex h-11 w-1/2 min-w-[100px] justify-center border border-steel-300 md:w-min"
          @click="emit('close')"
        >
          Not Now
        </ButtonComponent>
        <ButtonComponent
          variant="primary"
          class="flex h-11 w-1/2 !min-w-[130px] justify-center md:w-min"
          :is-loading="isCreateTruckPostingLoading"
          @click="handleRemove"
        >
          Yes, Remove
        </ButtonComponent>
      </section>
    </div>
  </bottom-sheet>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import { BottomSheet, ButtonComponent } from '@/components';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  capacity: {
    type: Object,
  },
});

const store = useStore();
const toast = useToast();

const emit = defineEmits(['close']);

const isCreateTruckPostingLoading = computed(
  () => store.state.loads.is_create_truck_posting_loading
);

const handleRemove = async () => {
  console.log('Remove truck:', props.capacity?.id);

  const res = await store.dispatch('loads/updateTruckPosting', {
    id: props.capacity?.id,
    is_active: false,
  });

  if ([200, 201, 204].includes(res?.status) && res.data) {
    toast.open({
      message: 'Capacity successfully removed.',
      position: 'top-right',
      duration: 5000,
    });
    emit('close');

    await store.dispatch('loads/getCarrierVehicles', {
      id: store.state.users?.currentUser?.requested_carrier_id,
      query: '&q[without_active_truck_postings]=1&q[is_eld_active_eq]=1',
    });
  } else {
    toast.open({
      message: 'There was an error, please try again.',
      type: 'error',
      position: 'top-right',
      duration: 5000,
    });
    emit('close');
  }
};
</script>

<style scoped>
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}
</style>
